import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_272: DocMigration = {
  maxSchemaVersion: "0.0.272",
  description: "Adds type to existing presets.",
  apply(json: any) {
    if (json.presets) {
      for (const presetId in json.presets) {
        const preset = json.presets[presetId];
        if (preset.name.includes(" at ")) {
          preset.type = "HOME_PLAN";
        } else {
          preset.type = "PRESETS";
        }
      }
    }
    return json;
  },
};

export default migration_0_0_272;
